import React from 'react';
import PropTypes from 'prop-types';
import { useDividerGradient } from '../gradient-utils';

export function WaveLayered({
  className,
  amplitude = 50,
  fadeOpacity,
  fadeDirection,
  softness,
  style
}) {
  const { defs, fill, mask } = useDividerGradient({ fadeOpacity, fadeDirection, softness });

  const scale = amplitude / 50;
  const base = 100;
  const y = val => base + (val - base) * scale;
  const minY = base - 70 * scale;
  const viewHeight = 120 - minY;
  const viewBox = `0 ${minY} 1200 ${viewHeight}`;

  return (
    <svg
      className={ className }
      style={ style }
      viewBox={ viewBox }
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      { defs }
      <g mask={ mask }>
        { /* Back layer - more transparent */ }
        <path
          d={ `M0,${y(80)} C150,${y(120)} 300,${y(40)} 450,${y(80)} C600,${y(120)} 750,${y(
            40
          )} 900,${y(80)} C1050,${y(120)} 1200,${y(40)} 1200,${y(80)} L1200,120 L0,120 Z` }
          fill={ fill }
          opacity='0.3'
        />
        { /* Middle layer */ }
        <path
          d={ `M0,${y(90)} C200,${y(50)} 400,${y(110)} 600,${y(70)} C800,${y(30)} 1000,${y(
            90
          )} 1200,${y(60)} L1200,120 L0,120 Z` }
          fill={ fill }
          opacity='0.5'
        />
        { /* Front layer - fully opaque */ }
        <path
          d={ `M0,${y(100)} C300,${y(60)} 600,${y(100)} 900,${y(70)} C1100,${y(50)} 1200,${y(
            80
          )} 1200,${y(90)} L1200,120 L0,120 Z` }
          fill={ fill }
        />
      </g>
    </svg>
  );
}

WaveLayered.propTypes = {
  className: PropTypes.string,
  amplitude: PropTypes.number,
  fadeOpacity: PropTypes.number,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  softness: PropTypes.number
};
